module.exports = __webpack_public_path__ + "img/zone250300.0e3f2eb4.png";